import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const navItems = [
    { key: 'nav.home', path: '/' },
    { key: 'nav.media', path: '/media' },
    { key: 'nav.videos', path: '/videos' },
  ];

  const switchLang = () => {
    const newLang = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(newLang);
  };

  return (
    <footer className="bg-primary-700 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            {/* Brand */}
            <div className="md:col-span-1">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mb-4">
                <img
                  src="https://storage.readdy-site.link/project_files/24d9f673-4dd5-4514-9bb2-bf7280a460c7/8955655c-e53a-4719-b771-f2c96d3769bf_4----Photoroom.png?v=a73ad237787a5912840cf1a463cb272f"
                  alt="Rotary International Peace Monument"
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-lg font-heading font-semibold leading-snug mb-3">
                {t('footer.title')}
              </h3>
              <p className="text-sm text-background-300/80 leading-relaxed">
                {t('footer.slogan')}
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-sm font-semibold text-secondary-400 mb-4 tracking-wider">
                {t('footer.nav')}
              </h4>
              <ul className="space-y-3">
                {navItems.map((item) => (
                  <li key={item.path}>
                    <button
                      onClick={() => {
                        navigate(item.path);
                        window.scrollTo(0, 0);
                      }}
                      className="text-sm text-background-300/80 hover:text-background-50 transition-colors duration-300"
                    >
                      {t(item.key)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Language */}
            <div>
              <h4 className="text-sm font-semibold text-secondary-400 mb-4 tracking-wider">
                {t('footer.lang')}
              </h4>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => i18n.language !== 'zh' && switchLang()}
                  className={`text-sm transition-colors duration-300 ${
                    i18n.language === 'zh'
                      ? 'text-background-50 font-medium'
                      : 'text-background-300/60 hover:text-background-200'
                  }`}
                >
                  中文
                </button>
                <span className="text-background-400/40">|</span>
                <button
                  onClick={() => i18n.language !== 'en' && switchLang()}
                  className={`text-sm transition-colors duration-300 ${
                    i18n.language === 'en'
                      ? 'text-background-50 font-medium'
                      : 'text-background-300/60 hover:text-background-200'
                  }`}
                >
                  English
                </button>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-10 pt-8 border-t border-background-400/20">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-400/50">
                {t('footer.copyright')}
              </p>
              <p className="text-xs text-background-400/40 font-heading italic">
                {t('footer.slogan')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}